
import Vue from "vue";

import TaxLookup from "../components/TaxLookup.vue";
import LevyMarketValueSearch from "../components/LevyMarketValueSearch.vue";

export default Vue.extend({
	name: "SchoolDistrictEstimator",

	props: ["disclaimer", "note"],

	data() {
		return {
			isLoading: true,
		};
	},
	components: {
		TaxLookup,
		LevyMarketValueSearch,
	},
});
